import { Invitation, Registerer, RegistererOptions, UserAgent, UserAgentOptions, Web } from 'sip.js';
import { prepSession, store } from '.'
import { salesforceOpenContact} from './salesforceHelper.js';

interface ISettings {
    server: string,
    username: string,
    password: string,
    uri: string
}

export default function getConfiguredUserAgent(settings: ISettings) {
    const tUri = UserAgent.makeURI(settings.uri);
    const options: UserAgentOptions = {
        sessionDescriptionHandlerFactory: Web.defaultSessionDescriptionHandlerFactory(),
        transportOptions: {
            server: settings.server,
            reconnectionTimeout: 5,
            maxReconnectionAttempts: 1000000,
            keepAliveInterval: 20,
        },
        logLevel: "error",
        authorizationUsername: settings.username,
        authorizationPassword: settings.password,
        uri: tUri,
        delegate: {
            onInvite: (session: Invitation) => {
                const maxSessions = store.state.sip.maxSessions;
                // Limit the maximum number of sessions
                if (maxSessions && store.state.sip.sessions.length >= maxSessions) {
                    session.reject();
                    return;
                }
		/*
		if(window.sforce) {
			console.log('open cti ' + window.sforce);
	        	console.log('open cti ' + window.sforce.opencti);
        		console.log( window.sforce.opencti);
    			window.sforce.opencti.setSoftphonePanelVisibility({visible: true, callback: (response: any) => {   
				console.log('-------------------------- opencall_back -----------'); 
				console.dir(response);
			} });
		}
	       	*/

	       console.log('Session here incoming call ------ i22');

                prepSession(session, store);
                store.commit('sip/addSession', session);

                // if this is the only session, set it as the current session
                store.commit('sip/activateSession', session);
                salesforceOpenContact(session, true);

                },
        }
    };

    // Get a user agent, ready to make calls
    const userAgent = new UserAgent(options);
    const registererOptions: RegistererOptions = { expires: 600 };
    const registerer = new Registerer(userAgent, registererOptions);
    
    userAgent.start().then(() => {
        registerer.register();
    });
    return userAgent;
}
